export enum SuperAdminPrivilege {
  roomInspector = 'roomInspector',
  userInspector = 'userInspector',
  canViewFeatureFlags = 'canViewFeatureFlags',
  canInvokeEmailTemplateHandler = 'canInvokeEmailTemplateHandler',
  canEditClickwraps = 'canEditClickwraps',

  /** allow editing the codeless access toggle on sections and organizations */
  canEditCodelessAccess = 'canEditCodelessAccess',

  // prompt related privileges
  canEditOutputPrompt = 'canEditOutputPrompt',
  canInstallPrompts = 'canInstallPrompts',

  /** override promotion rules if the user has this privilege and applying special admin approvedFree promo */
  canAlwaysApplyAdminApprovedFreePromotion = 'canAlwaysApplyAdminApprovedFreePromotion',
}
